import { Stack, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  participant: { name: string; perspective: string };
  isEven: boolean;

  getRealPerspective(id: string): string;
}

const ParticipantCreationItem: React.FC<Props> = ({ participant, isEven, getRealPerspective }) => {
  const { classes, cx } = useStyles({ isEven });

  return (
    <Stack className={classes.participant} direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={2}>
      <Stack direction={'row'} alignItems={'center'} gap={1} style={{ flexBasis: '50%' }}>
        <Typography className={classes.text} style={{ textTransform: 'capitalize' }}>
          {participant.name}
        </Typography>
      </Stack>

      <div style={{ flexBasis: '30%' }}>
        <Typography className={cx(classes.text, 'perspective')}>{getRealPerspective(participant.perspective)}</Typography>
      </div>

      <Typography className={classes.text} align={'right'} style={{ flexBasis: '20%' }}>
        neu
      </Typography>
    </Stack>
  );
};

const useStyles = makeStyles<{ isEven: boolean }>()((theme, { isEven }) => ({
  participant: {
    position: 'relative',
    width: '100%',
    padding: '8px 16px',
    background: isEven ? '#FFF' : theme.palette.backgrounds.main,
    minHeight: '47px',
  },
  text: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
    '&.perspective': {
      padding: '4px 6px',
    },
  },
}));

export default ParticipantCreationItem;
